import React, { ReactNode, FC, PropsWithChildren } from 'react';

import { theme } from '@lucid/theme';

import ThemeProvider from '../../theme-provider/theme-provider';
import ABTest from '../../ab-test/ab-test';
// import buttons from './buttons';
import { Products } from '../../../types/types';

interface UnifyCtaButtonsProps {
  children: ReactNode;
  product: Products.Site;
}

const ABTestThemeProviderUnifyCtaButtons: FC<PropsWithChildren<UnifyCtaButtonsProps>> = ({ children, product }) => {
  // Removing for now while we look into some weird reporting behavior
  // const alternativeTheme = Object.assign({}, theme);
  // alternativeTheme.buttons = buttons as unknown as LucidTheme['buttons'];

  return (
    <ABTest isAboveTheFold branchesToRender={[]} test="Y22Q1_UnifiedSuiteCTAs">
      <ThemeProvider product={product} theme={theme}>
        {children}
      </ThemeProvider>
    </ABTest>
  );
};

export default ABTestThemeProviderUnifyCtaButtons;
